import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UiModule } from '@haleo-frontend/ui';
import { UtilsModule } from '@haleo-frontend/utils';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';
import { MomentModule } from 'ngx-moment';
import { AppointmentComponent } from './components/appointment/appointment.component';
import { ChangeLanguageComponent } from './components/change-language/change-language.component';
import { DataRefreshComponent } from './components/data-refresh/data-refresh.component';
import { PartnerLogoComponent } from './components/partner-logo/partner-logo.component';
import { PaymentComponent } from './components/payment/payment.component';
import { QuestionComponent } from './components/question/question.component';
import { ScreenerFooterComponent } from './components/screener-footer/screener-footer.component';
import { ScreenerHeaderComponent } from './components/screener-header/screener-header.component';
import { ToastModal } from './components/toast/toast.modal';
import { ToolSkeletonComponent } from './components/tool-skeleton/tool-skeleton.component';
import { DefaultImageDirective } from './directives/default-image.directive';

import { ScrollVanishDirective } from './directives/scroll-vanish.directive';
import { MinutesToTimePipe } from './pipes/minutes-to-time.pipe';
import { TranslateWithFallbackPipe } from './pipes/translate.pipe';

@NgModule({
    declarations: [
        ScrollVanishDirective,
        DefaultImageDirective,
        //
        QuestionComponent,
        AppointmentComponent,
        PaymentComponent,
        ScreenerHeaderComponent,
        ScreenerFooterComponent,
        DataRefreshComponent,
        ToastModal,
        PartnerLogoComponent,
        ToolSkeletonComponent,
        ChangeLanguageComponent,
        //
        TranslateWithFallbackPipe,
        MinutesToTimePipe
    ],
    imports: [
        IonicModule,
        CommonModule,
        TranslateModule,
        FormsModule,
        MomentModule,
        ReactiveFormsModule,
        NgxMaskModule.forRoot({}),
        RouterModule.forChild([]),
        UiModule,
        UtilsModule
    ],
    exports: [
        IonicModule,
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMaskModule,
        UtilsModule,
        //
        ScrollVanishDirective,
        DefaultImageDirective,
        //
        QuestionComponent,
        AppointmentComponent,
        PaymentComponent,
        ScreenerHeaderComponent,
        ScreenerFooterComponent,
        DataRefreshComponent,
        ToastModal,
        PartnerLogoComponent,
        ToolSkeletonComponent,
        ChangeLanguageComponent,
        //
        TranslateWithFallbackPipe,
        MinutesToTimePipe,
        //
        UiModule
    ]
})
export class SharedModule {
}
